/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 10:22:58 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import edit from './edit';
import icon from '@material-ui/icons/Announcement';

export default {
  list,
  edit,
  icon,
};
